(() => {
  if (window.__mkoRetentionReady) return;
  window.__mkoRetentionReady = true;

  const destinations = [
    { label: 'Ransom 50%', href: '/collections/ransom-50' },
    { label: 'Paper Money', href: '/collections/paper-money-22-07' },
    { label: 'Beachwear', href: '/collections/beachwear' },
    { label: 'Tutti i prodotti', href: '/collections/all' }
  ];

  const makeShortcuts = (context = 'search') => {
    const nav = document.createElement('nav');
    nav.className = 'mko-search-shortcuts';
    nav.setAttribute('aria-label', 'Collegamenti rapidi');

    const label = document.createElement('span');
    label.className = 'mko-search-shortcuts__label';
    label.textContent = context === '404' ? 'Potrebbero interessarti' : 'Ricerche rapide';
    nav.appendChild(label);

    destinations.forEach((item) => {
      const link = document.createElement('a');
      link.href = item.href;
      link.textContent = item.label;
      link.dataset.mkoRetentionLink = context;
      nav.appendChild(link);
    });

    return nav;
  };

  const decorateSearch = () => {
    const formWrap = document.querySelector('[data-ui-component="Main Search Section"] .main-search__search-form');
    const input = document.querySelector('#searchInTemplate');
    if (input) input.placeholder = 'Cerca prodotti, brand o collezioni';

    if (formWrap && !formWrap.parentElement?.querySelector('.mko-search-shortcuts')) {
      formWrap.insertAdjacentElement('afterend', makeShortcuts('search'));
    }

    const searchRoot = document.querySelector('[data-ui-component="Main Search Section"]');
    if (!searchRoot || searchRoot.querySelector('.mko-search-empty')) return;

    const performed = new URLSearchParams(window.location.search).has('q');
    const countNode = searchRoot.querySelector('.js-search-count');
    const resultCards = searchRoot.querySelectorAll('.main-search_result');
    const resultCount = Number(countNode?.dataset?.resultsCount || resultCards.length || 0);

    if (performed && resultCount === 0) {
      const panel = document.createElement('div');
      panel.className = 'mko-search-empty';
      panel.innerHTML = '<strong>Nessun risultato preciso</strong><p>Prova con il nome del brand, del modello o della categoria. In alternativa, apri una delle collezioni più consultate.</p><div class="mko-search-empty__links"></div>';
      const links = panel.querySelector('.mko-search-empty__links');
      destinations.forEach((item) => {
        const link = document.createElement('a');
        link.href = item.href;
        link.textContent = item.label;
        link.dataset.mkoRetentionLink = 'search_empty';
        links.appendChild(link);
      });
      searchRoot.querySelector('.results')?.appendChild(panel);
    }
  };

  const decorate404 = () => {
    const root = document.querySelector('.section-404');
    if (!root || root.querySelector('.mko-search-shortcuts')) return;
    const input = root.querySelector('input[name="q"]');
    if (input) input.placeholder = 'Cerca un prodotto o un brand';
    const buttons = root.querySelector('.s-header__buttons');
    if (buttons) buttons.insertAdjacentElement('afterend', makeShortcuts('404'));
  };

  const decorateContact = () => {
    const form = document.querySelector('[data-ui-component="Contact Form Section"] .form-contact');
    if (!form || form.querySelector('.mko-contact-note')) return;
    const note = document.createElement('p');
    note.className = 'mko-contact-note';
    note.textContent = 'Per richieste relative a un acquisto, inserisci il numero dell’ordine nel campo dedicato: ci aiuterà a individuare più rapidamente la pratica.';
    form.prepend(note);
  };

  const decorateNewsletter = () => {
    const input = document.querySelector('footer.js-footer .footer-newsletter input[type="email"]');
    const button = document.querySelector('footer.js-footer .footer-newsletter button[type="submit"]');
    if (input) input.placeholder = 'La tua email';
    if (button) button.textContent = 'Iscriviti';
  };

  const cleanupFooterCredit = () => {
    document.querySelectorAll('footer.js-footer .footer__content__bottom a').forEach((link) => {
      if (!/shopify/i.test(`${link.href} ${link.textContent}`)) return;
      const small = link.closest('small');
      if (small) small.remove();
    });

    const copyright = document.querySelector('footer.js-footer .footer__content__bottom small');
    if (copyright) copyright.innerHTML = copyright.innerHTML.replace(/\s*[•·]\s*$/, '');
  };

  const decoratePredictiveSearch = () => {
    const input = document.querySelector('#predictiveSearch_Input');
    if (input) input.placeholder = 'Cerca prodotti, brand o collezioni';
  };

  const trackShortcut = (event) => {
    const link = event.target.closest?.('[data-mko-retention-link]');
    if (!link) return;
    try {
      if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mko_navigation_shortcut_click',
        shortcut_context: link.dataset.mkoRetentionLink || '',
        destination_path: new URL(link.href, window.location.origin).pathname
      });
    } catch (_) {}
  };

  const init = () => {
    decorateSearch();
    decorate404();
    decorateContact();
    decorateNewsletter();
    decoratePredictiveSearch();
    cleanupFooterCredit();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('click', trackShortcut, { passive: true });
  document.addEventListener('shopify:section:load', () => window.requestAnimationFrame(init));
})();